export default __webpack_public_path__ + "static/media/loader.25946ce5.svg";